<template>
  <a-drawer
    width="60%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-page-header
        title="设备固件包信息"
        sub-title="Device firmware package information"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item
              label="开启功能设置"
              prop="firmwareFunctionSwitch"
            >
              <a-switch
                v-model="form.firmwareFunctionSwitch"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="固件名称"
              prop="firmwareName"
            >
              <a-input
                v-model="form.firmwareName"
                style='width: 100%;'
                placeholder="请输入固件名称"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="固件版本"
              prop="firmwareVersion"
            >
              <a-input
                v-model="form.firmwareVersion"
                style='width: 100%;'
                placeholder="请输入固件版本"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="产品编码"
              prop="firmwareProductSn"
            >
              <a-input
                v-model="form.firmwareProductSn"
                style='width: 100%;'
                placeholder="请输入产品编码"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="产品型号"
              prop="firmwareProductModel"
            >
              <a-input
                v-model="form.firmwareProductModel"
                style='width: 100%;'
                placeholder="请输入产品型号"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="固件文件"
              prop="firmwareUrl"
            >
              <a-upload
                name="file"
                :action="baseUrl+'/common/local/file/upload'"
                :showUploadList="true"
                :file-list="fileList"
                @change="handleChange"
              >
                <a-button icon="upload">点击上传</a-button>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {updateDeviceDistribution, updateDeviceParamFirmwareBatch} from '@/api/saifuneng/device'
export default {
  name: 'CreateParamFirmwareBatchForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      submitLoading: false,
      formTitle: '',
      fileList: [],
      deviceList: [],
      // 表单参数
      form: {
        idList: [],
        firmwareFunctionSwitch: null,
        firmwareName: null,
        firmwareVersion: null,
        firmwarePath: null,
        firmwareUrl: null,
        firmwareSize: null,
        firmwareProductSn: null,
        firmwareProductModel: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // firmwareName: [
        //   { required: true, message: '固件名称不能为空', trigger: 'blur' }
        // ],
        // firmwareUrl: [
        //   { required: true, message: '固件文件不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        idList: [],
        firmwareFunctionSwitch: null,
        firmwareName: null,
        firmwareVersion: null,
        firmwarePath: null,
        firmwareUrl: null,
        firmwareSize: null,
        firmwareProductSn: null,
        firmwareProductModel: null,
        remark: null
      }
      this.fileList = []
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 分配 */
    handleFirmware(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '固件信息'
      this.deviceList = row
      row.forEach(item => {
        this.form.idList.push(item.id)
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.firmwareFunctionSwitch = this.form.firmwareFunctionSwitch ? 1 : 0
          updateDeviceParamFirmwareBatch(this.form).then(response => {
            this.$message.success(
              '更新成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },

    onChange (checked) {
      // console.log(checked)
    },
    handleChange(info) {
      this.fileList = info.fileList.slice(-1)
      if (info.file.status === 'removed') {
        this.form.firmwarePath = null
        this.form.firmwareUrl = ''
        this.form.firmwareSize = null
        return
      }
      if (info.file.status === 'done') {
        const data = info.file.response
        const fileUrl = data.data
        this.form.firmwarePath = info.file.name
        this.form.firmwareUrl = this.baseUrl + fileUrl
        this.form.firmwareSize = info.file.size
        this.fileList = [{
          uid: info.file.uid,
          name: info.file.name,
          status: 'done',
          url: this.baseUrl + fileUrl
        }]
        this.$message.success(`上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
      }
    }

  }
}
</script>
